module.exports = "/_next/static/images/apple-touch-57-55739f8f116de1bb3a61aa26aae46954.png";